import React from 'react'
import { Box, styled, SxProps } from '@mui/material'

import { DynamicInputForm, FormProps } from '../DynamicInputForm'

import { ThemeProvider } from '~/theme'

type SignupFormProps = {
  data: FormProps['formProps']
  sx: SxProps
}

const Form = styled(Box)`
  ${({ theme }) => `
    form {
      border-radius: ${theme.spacing(2)};
      position: relative;
      background: ${theme.palette.background.default};
      padding: ${theme.spacing(1)};

      .MuiInputBase-root {
        min-width: auto;
        flex: 1;

        input {
          border: none;
          background: ${theme.palette.background.paper};
        }
      }

      button {
        background: ${theme.palette.primary.main};

        :hover {
          background: ${theme.palette.primary.dark};
          box-shadow: none;
        }
      }
    }
  `}
`

export const SignupForm = ({ data, sx }: SignupFormProps) => (
  <ThemeProvider mode='light'>
    <Form data-test='signup-form' sx={{ ...sx }}>
      <DynamicInputForm
        formProps={data}
        singleFieldForm
        errorAfterButton
        sx={{
          bgcolor: { laptop: 'text.primary' },
          display: {
            xs: 'block',
            mobile: 'flex',
            tablet: 'block',
            laptop: 'flex'
          },
          mt: { xs: 5, laptop: 0 },
          '.MuiInputBase-root': {
            minWidth: 270,
            input: {
              /* Can be removed after tailwind is removed */
              ':-webkit-autofill': {
                caretColor: '#fff',
                WebkitBoxShadow: '0 0 0 25px #202129 inset',
                WebkitTextFillColor: '#fff'
              }
            }
          },
          button: {
            mt: {
              xs: 1,
              mobile: 0,
              tablet: 1,
              laptop: 0
            },
            width: {
              xs: '100%',
              mobile: 'auto',
              tablet: '100%',
              laptop: 'auto'
            },
            '&.Mui-disabled': {
              bgcolor: 'text.primary',
              fontSize: 16,
              px: 4
            }
          }
        }}
      />
    </Form>
  </ThemeProvider>
)
